import { FC, ReactNode } from "react";

export interface BackgroundSectionProps {
  className?: string;
  children?: ReactNode;
}

const BackgroundSection: FC<BackgroundSectionProps> = ({
  className = "bg-neutral-100 dark:bg-black dark:bg-opacity-20 ",
  children,
}) => {
  return (
    <div
      className={`container max-w-[1280px] nc-BackgroundSection absolute inset-y-0  2xl:max-w-screen-2xl  xl:rounded-[40px] z-0 ${className}`}
      data-nc-id="BackgroundSection"
    >
      {children}
    </div>
  );
};

export default BackgroundSection;
